import React from 'react';
import { Button } from '@material-ui/core';

import Organization from 'entities/organization/model';

const RegisterWithPayPalBlock = ({
  children,
  organization,
}: {
  children: React.ReactNode;
  organization: Organization;
}) => {
  const payPalUrl = `https://www.paypal.com/${organization.locationObject.countryCode?.toLowerCase()}/givingfund/home`;

  return (
    <>
      <ol>
        <li>
          <a href={payPalUrl} target="_blank" rel="noreferrer">
            Register with PayPal
          </a>{' '}
          and enroll your organization (It only takes a few minutes!)
        </li>
        {children}
      </ol>
      <p style={{ fontWeight: 'bold' }}>
        Our support fees are amongst the lowest in the market and cover receipting, tracking, and
        notification.
      </p>
      <p style={{ fontWeight: 'bold' }}>We can’t wait to help your nonprofit grow!</p>
      <div style={{ marginTop: 15 }}>
        <Button color="primary" variant="contained" href={payPalUrl} target="_blank">
          Register with PayPal
        </Button>
      </div>
    </>
  );
};

export default RegisterWithPayPalBlock;
